export const registerTypes = ['HRA', 'HRB', 'GnR', 'PR', 'VR', 'GsR'] as const
export type RegisterType = (typeof registerTypes)[number]

export const registrationAuthorityNames = [
  'Aachen',
  'Altenburg',
  'Amberg',
  'Ansbach',
  'Apolda',
  'Arnsberg',
  'Arnstadt',
  'Arnstadt Zweigstelle Ilmenau',
  'Aschaffenburg',
  'Augsburg',
  'Aurich',
  'Bad Hersfeld',
  'Bad Homburg v.d.H.',
  'Bad Kreuznach',
  'Bad Oeynhausen',
  'Bad Salzungen',
  'Bamberg',
  'Bayreuth',
  'Berlin (Charlottenburg)',
  'Bielefeld',
  'Bochum',
  'Bonn',
  'Braunschweig',
  'Bremen',
  'Chemnitz',
  'Coburg',
  'Coesfeld',
  'Cottbus',
  'Darmstadt',
  'Deggendorf',
  'Dortmund',
  'Dresden',
  'Duisburg',
  'Düren',
  'Düsseldorf',
  'Eisenach',
  'Erfurt',
  'Eschwege',
  'Essen',
  'Flensburg',
  'Frankfurt am Main',
  'Frankfurt/Oder',
  'Freiburg',
  'Friedberg',
  'Fritzlar',
  'Fulda',
  'Fürth',
  'Gelsenkirchen',
  'Gera',
  'Gießen',
  'Gotha',
  'Göttingen',
  'Greiz',
  'Gütersloh',
  'Hagen',
  'Hamburg',
  'Hamm',
  'Hanau',
  'Hannover',
  'Heilbad Heiligenstadt',
  'Hildburghausen',
  'Hildesheim',
  'Hof',
  'Homburg',
  'Ingolstadt',
  'Iserlohn',
  'Jena',
  'Kaiserslautern',
  'Kassel',
  'Kempten (Allgäu)',
  'Kiel',
  'Kleve',
  'Koblenz',
  'Köln',
  'Königstein',
  'Korbach',
  'Krefeld',
  'Landau',
  'Landshut',
  'Langenfeld',
  'Lebach',
  'Leipzig',
  'Lemgo',
  'Limburg',
  'Lübeck',
  'Ludwigshafen a.Rhein (Ludwigshafen)',
  'Lüneburg',
  'Mainz',
  'Mannheim',
  'Marburg',
  'Meiningen',
  'Memmingen',
  'Merzig',
  'Mönchengladbach',
  'Montabaur',
  'Mühlhausen',
  'München',
  'Münster',
  'Neubrandenburg',
  'Neunkirchen',
  'Neuruppin',
  'Neuss',
  'Nordhausen',
  'Nürnberg',
  'Offenbach am Main',
  'Oldenburg (Oldenburg)',
  'Osnabrück',
  'Ottweiler',
  'Paderborn',
  'Passau',
  'Pinneberg',
  'Pößneck',
  'Pößneck Zweigstelle Bad Lobenstein',
  'Potsdam',
  'Recklinghausen',
  'Regensburg',
  'Rostock',
  'Rudolstadt',
  'Saarbrücken',
  'Saarlouis',
  'Schweinfurt',
  'Schwerin',
  'Siegburg',
  'Siegen',
  'Sömmerda',
  'Sondershausen',
  'Sonneberg',
  'Stadthagen',
  'Stadtroda',
  'Steinfurt',
  'Stendal',
  'St. Ingbert (St Ingbert)',
  'Stralsund',
  'Straubing',
  'Stuttgart',
  'St. Wendel (St Wendel)',
  'Suhl',
  'Tostedt',
  'Traunstein',
  'Ulm',
  'Völklingen',
  'Walsrode',
  'Weiden i. d. OPf.',
  'Weimar',
  'Wetzlar',
  'Wiesbaden',
  'Wittlich',
  'Wuppertal',
  'Würzburg',
  'Zweibrücken',
] as const
export type RegistrationAuthorityName = (typeof registrationAuthorityNames)[number]

/** Courts the register service knows under a name other than the one the dropdown shows. */
export const registrationAuthorityApiNames: Partial<Record<RegistrationAuthorityName, string>> = {
  'Berlin (Charlottenburg)': 'Charlottenburg',
}

export function registrationAuthorityApiName(name: string): string {
  return registrationAuthorityApiNames[name as RegistrationAuthorityName] ?? name
}
